import {
  Users, ClipboardList, Phone, Globe, ShieldCheck, Building2, Award, Star, Heart, Home,
  DollarSign, TrendingUp, CalendarDays, BadgeCheck, Briefcase, Umbrella, Store,
} from 'lucide-react';

/** Icon keys the API accepts for stats / products → lucide components. */
export const ICONS = {
  users: Users, clipboard: ClipboardList, phone: Phone, globe: Globe, shield: ShieldCheck,
  building: Building2, award: Award, star: Star, heart: Heart, home: Home, dollar: DollarSign,
  trending: TrendingUp, calendar: CalendarDays, check: BadgeCheck, briefcase: Briefcase, umbrella: Umbrella, store: Store,
};

export const ICON_LABELS = {
  users: 'People', clipboard: 'Clipboard', phone: 'Phone', globe: 'Globe', shield: 'Shield', building: 'Building',
  award: 'Award', star: 'Star', heart: 'Heart', home: 'Home', dollar: 'Dollar', trending: 'Growth',
  calendar: 'Calendar', check: 'Verified', briefcase: 'Briefcase', umbrella: 'Umbrella', store: 'Storefront',
};

/** @param {string} key @returns {import('react').ComponentType<any>} */
export const iconFor = (key) => ICONS[key] || ShieldCheck;
